import React from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '../Modal'
import womanNotebook from '../../../svg/womanNotebook.svg'
import { isEducation } from 'common/utils/permissions'
import TrialActivatedModal from '../TrialEndedModal/components/TrialActivatedModal/TrialActivatedModal'
import './TrialExtensionModal.scss'

const TrialExtensionModal = ({ onClose }) => {
    const { t } = useTranslation()
    const _isEducation = isEducation()
    return (
        <Modal closeOnEsc={false} closeOnOverlayClick={false} onClose={() => onClose()} isShowCloseIcon>
            {_isEducation ? (
                <div className="trial-success-modal-education">
                    <img src={womanNotebook} alt="" />
                    <p className="subscription-title">
                        <b>{t('Get started with our free Education plan')}</b>
                    </p>
                    <p className="subscription-text">
                        {t('We have created special free plan for teachers, students and education programs.')}
                        &nbsp;
                        <b>{t('Start creating your educational projects absolutely free.')}</b>
                        &nbsp;
                        {t('If you wish, you can change your tariff plan.')}
                    </p>
                    <div className="button-container">
                        <button className="ok-button" onClick={onClose}>
                            {t("Ok, let's get started!")}
                        </button>
                    </div>
                </div>
            ) : (
                <TrialActivatedModal onClose={onClose} />
            )}
        </Modal>
    )
}

export default TrialExtensionModal
